import React from 'react';
import { Button } from './ui/Button';
import { Shield, Zap, FileText, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-black text-white pt-12 pb-20 px-4 overflow-hidden" data-id="element-73">
      {/* Background subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-brand/20 blur-[120px] rounded-full pointer-events-none" data-id="element-74"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-75">
        <div className="text-center mb-8" data-id="element-76">
          <span className="inline-block py-1 px-3 rounded-full bg-brand/10 border border-brand/30 text-brand font-bold tracking-widest text-sm mb-6" data-id="element-77">
            🥗 BIBLIOTECAPRO™
          </span>
          <h1 className="font-display font-black md:text-7xl lg:text-8xl tracking-tight mb-6 uppercase text-balance text-[28px]" data-id="element-78">
            Todo tu consultorio.
            <br data-id="element-79" />
            <span className="text-brand text-[32px]" data-id="element-80">Listo. Desde hoy.</span>
          </h1>
          <p className="md:text-2xl text-gray-300 font-medium max-w-3xl mx-auto mb-8 text-balance text-[15px]" data-id="element-81">
            El sistema N°1 para nutricionistas en Argentina. Fichas, protocolos,
            recetas, redes y gestión. Sin buscar. Sin armar. Sin perder
            domingos.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 mb-12" data-id="element-82">
          <div className="w-full lg:w-1/2 relative" data-id="element-83">
            <img src="https://cdn.magicpatterns.com/uploads/rFNV58EnGP6SSBBpRDdg39/MOCKUP_(1).png" alt="Pack Nutrición Pro Mockup" className="w-full h-auto object-contain drop-shadow-2xl animate-pulse-slow brightness-110 contrast-110 saturate-125" data-id="element-84" />
          </div>

          <div className="w-full lg:w-1/2 flex flex-col gap-6" data-id="element-85">
            <div className="space-y-4" data-id="element-86">
              {['100% Formato PDF Digital', 'Acceso inmediato en 5 minutos', 'Hecho específicamente para Argentina', '6 Tomos Completos + 6 Bonos Exclusivos'].map((item, i) => <div key={i} className="flex items-center gap-3 text-lg font-medium" data-id="element-87">
                  <CheckCircle2 className="text-brand w-6 h-6 shrink-0" data-id="element-88" />
                  <span data-id="element-89">{item}</span>
                </div>)}
            </div>

            <div className="pt-6" data-id="element-90">
              <Button size="xl" fullWidth onClick={scrollToPricing} className="mb-4" data-id="element-91">
                QUIERO MI PACK NUTRICIÓN PRO AHORA
              </Button>

              <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-400 font-medium" data-id="element-92">
                <div className="flex items-center gap-1" data-id="element-93">
                  <Shield className="w-4 h-4" data-id="element-94" /> Garantía 7 días
                </div>
                <div className="flex items-center gap-1" data-id="element-95">
                  <Zap className="w-4 h-4" data-id="element-96" /> Pago seguro
                </div>
                <div className="flex items-center gap-1" data-id="element-97">
                  <FileText className="w-4 h-4" data-id="element-98" /> Mercado Pago
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}